import axios from 'axios'

const state = {
  items: [],
  isLoading: false,
  error: null
}

const mutations = {
  SET_ITEMS(state, data) {
    state.items = data
  },
  SET_LOADING(state, value) {
    state.isLoading = value
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  }
}

// Вспомогательная функция для извлечения сообщения об ошибке
function extractErrorMessage(err, defaultMessage) {
  if (err.response?.data?.error) {
    return err.response.data.error
  }
  if (err.response?.data?.message) {
    return err.response.data.message
  }
  if (err.response?.data?.title) {
    return err.response.data.title
  }
  if (typeof err.response?.data === 'string') {
    return err.response.data
  }
  return defaultMessage
}

function showSnackbar(commit, text, color) {
  commit("SET_SNACKBAR", {
    text,
    timeout: color === "error" ? 7500 : 5000,
    color,
    linkText: "",
    show: true,
  }, { root: true })
}

const actions = {
  async fetchAllTopSales({ commit }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')

    try {
      const response = await axios.get('/TopSales/GetAllAsync')
      commit('SET_ITEMS', response.data)
    } catch (err) {
      const errorMessage = extractErrorMessage(err, 'Ошибка при загрузке топ продаж')
      commit('SET_ERROR', errorMessage)
      showSnackbar(commit, errorMessage, "error")
      throw err
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createTopSales({ commit }, data) {
    commit('CLEAR_ERROR')

    try {
      const response = await axios.post('/TopSales/CreateAsync', data)
      showSnackbar(commit, 'Запись успешно добавлена', "success")
      return response.data
    } catch (err) {
      const errorMessage = extractErrorMessage(err, 'Ошибка при создании записи')
      commit('SET_ERROR', errorMessage)
      showSnackbar(commit, errorMessage, "error")
      throw err
    }
  },

  async updateTopSales({ commit }, data) {
    commit('CLEAR_ERROR')

    try {
      const response = await axios.put('/TopSales/UpdateAsync', data)
      showSnackbar(commit, 'Запись успешно обновлена', "success")
      return response.data
    } catch (err) {
      const errorMessage = extractErrorMessage(err, 'Ошибка при обновлении записи')
      commit('SET_ERROR', errorMessage)
      showSnackbar(commit, errorMessage, "error")
      throw err
    }
  },

  async deleteTopSales({ commit }, id) {
    commit('CLEAR_ERROR')

    try {
      await axios.delete(`/TopSales/DeleteAsync?id=${id}`)
      showSnackbar(commit, 'Запись успешно удалена', "success")
    } catch (err) {
      const errorMessage = extractErrorMessage(err, 'Ошибка при удалении записи')
      commit('SET_ERROR', errorMessage)
      showSnackbar(commit, errorMessage, "error")
      throw err
    }
  },

  // Возвращает название товара или null, если товар не найден (404 — не ошибка)
  async fetchGoodsName({ commit }, goodsId) {
    try {
      const response = await axios.get(`/TopSales/GetGoodsNameByIdAsync?goodsId=${goodsId}`)
      return response.data.fullName
    } catch (err) {
      if (err.response?.status === 404) {
        return null
      }
      const errorMessage = extractErrorMessage(err, 'Ошибка при поиске товара')
      showSnackbar(commit, errorMessage, "error")
      throw err
    }
  },

  clearError({ commit }) {
    commit('CLEAR_ERROR')
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
